export const apiCreate = (): string => '/commercial/serviceCategories/'
export const apiList = (id?: string): string =>
  !id
    ? '/commercial/serviceCategories/'
    : `/commercial/serviceCategories/view/${id}`
export const apiUpdate = (id: string): string =>
  `/commercial/serviceCategories/update/${id}`
export const apiDelete = (id: string): string =>
  `/commercial/serviceCategories/${id}`
